var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.45026 17.7644C9.7644 18.0785 10.2984 18.0785 10.6126 17.7644L19.8482 8.5288C20.1623 8.21466 20.1623 7.68063 19.8482 7.36649L18.7173 6.2356C18.4031 5.92147 17.9005 5.92147 17.5864 6.2356L10.0471 13.7749L6.49738 10.2565C6.18325 9.94241 5.68063 9.94241 5.36649 10.2565L4.2356 11.3874C3.92147 11.7016 3.92147 12.2356 4.2356 12.5497L9.45026 17.7644Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.6d8ea307ed81f9b38320c97efebf72fb.svg";
export { ForwardRef as ReactComponent };